<template>
  <div>
    <!-- <page-header :title="$t('bill.subscription')" /> -->
    <page-body>
      <subscription-list id="BillSubscriptionList" />
    </page-body>
  </div>
</template>

<script>
import SubscriptionList from './components/List'

export default {
  name: 'BillSubscription',
  components: {
    SubscriptionList,
  },
}
</script>
